import { Button, Dialog, DialogActions, DialogContent, MenuItem, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import { CASH_REQUISITION_STATUS, PAYMENT_TYPE } from "../../../../../shared/constants";
import AttachmentInput from "../../../components/AttachmentInput";
import SearchItem from "../../../components/SearchItem";
import request from "../../../request";
import { errorToast } from "../../../toast";
import { hideLoading, showLoading } from "../../../loading";
import swal from "sweetalert";

export default class Approve extends Component {

   state = {
      type: '',
      proofOfDisbursement: null,
      bankAccount: null,
      expenseAccount: null,
   }

   fetchBankAccounts = async () => {
      const { data } = await request.get('/api/general/quickbooks/bank-accounts');
      return data.accounts;
   }

   fetchExpenseAccounts = async () => {
      const { data } = await request.get('/api/general/quickbooks/accounts', { params: { type: 'expense' } });
      return data.accounts;
   }

   submit = async () => {

      // validate form
      const txtBankAccount = document.getElementById('txt-bank-account');
      const txtExpenseAccount = document.getElementById('txt-expense-account');
      const txtType = document.getElementById('txt-type');
      const txtProofOfDisbursement = document.getElementById('attachment-input');
      const { bankAccount, expenseAccount, type, proofOfDisbursement } = this.state;

      if (!type) {
         errorToast('Payment type is required');
         return txtType.focus();
      }

      if (!bankAccount) {
         errorToast('Bank account is required');
         return txtBankAccount.focus();
      }

      if (!expenseAccount) {
         errorToast('Expense account is required');
         return txtExpenseAccount.focus();
      }

      if (!type) {
         errorToast('Payment type is required');
         return txtType.focus();
      }

      if (!proofOfDisbursement) {
         errorToast('Proof of disbursement is required');
         return txtProofOfDisbursement.focus();
      }

      try {

         showLoading();

         const data = {
            status: CASH_REQUISITION_STATUS.APPROVED,
            payment: {
               type,
               bank_account: bankAccount.id,
               expense_account: expenseAccount.id,
               proof_of_disbursement: {
                  name: proofOfDisbursement.name,
                  ext: proofOfDisbursement.ext,
                  base64: proofOfDisbursement.base64,
               }
            }
         }

         const res = await request.patch(`/api/finance/cash-requisitions/${this.props.cashRequisition._id}`, data);
         this.props.onClose(res.data);
         swal('Success', 'Cash requisition approved successfully', 'success');

   
      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }
   }

   render() {

      return <Dialog open fullWidth maxWidth="xs">
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Approve Cash Requisition
         </DialogTitleWithCloseButton>
         <DialogContent dividers>
            <div className="grid grid-cols-1 gap-4">
               <TextField
                  id="txt-type"
                  label="Payment type"
                  variant="outlined"
                  size="small"
                  fullWidth
                  select
                  value={this.state.type}
                  onChange={e => this.setState({ type: e.target.value })}
               >
                  {
                     Object
                        .values(PAYMENT_TYPE)
                        .map((type, index) => (
                           <MenuItem key={index} value={type}>
                              {type.replace(/-/g, ' ').toUpperCase()}
                           </MenuItem>
                        ))
                  }
               </TextField>
               <AttachmentInput
                  id="attachment-input"
                  label="Proof of Disbursement"
                  name={this.state.proofOfDisbursement?.name}
                  onChange={proofOfDisbursement => this.setState({ proofOfDisbursement })}
               />
               <SearchItem
                  label="Bank Account"
                  fetchData={this.fetchBankAccounts}
                  onChange={bankAccount => this.setState({ bankAccount })}
                  value={this.state.bankAccount}
                  transformOption={option => ({ ...option, label: option.name })}
                  size="small"
               />
               <SearchItem
                  id="txt-expense-account"
                  label="Expense Account"
                  fetchData={this.fetchExpenseAccounts}
                  onChange={expenseAccount => this.setState({ expenseAccount })}
                  value={this.state.expenseAccount}
                  transformOption={option => ({ ...option, label: option.name })}
                  size="small"
               />
            </div>
         </DialogContent>
         <DialogActions>
            <Button variant="contained" onClick={this.submit}>
               Approve
            </Button>
         </DialogActions>
      </Dialog>
   }


}